/**
 * VIPLayout — thin wrapper around EliteOperatorLayout.
 * Every page that used the old top-only VIP chrome now gets left rail + top ticket nav.
 */
import EliteOperatorLayout from "@/components/EliteOperatorLayout";
import { VIP } from "@/lib/vipTheme";

interface VIPLayoutProps {
  children: React.ReactNode;
  title?: string;
  titleTone?: "blue" | "red";
}

export default function VIPLayout({ children, title, titleTone = "blue" }: VIPLayoutProps) {
  return (
    <EliteOperatorLayout title={title}>
      {title && (
        <div style={{ marginBottom: "24px" }}>
          <div
            className="vip-title-bar"
            style={titleTone === "blue" ? { background: VIP.titleBlue } : { background: VIP.titleRed || "#F43F5E" }}
          />
          <h1 className={`vip-title${titleTone === "red" ? " vip-title-red" : ""}`}>{title}</h1>
        </div>
      )}
      {children}
    </EliteOperatorLayout>
  );
}
